import { render, staticRenderFns } from "./ChartsBarPie.vue?vue&type=template&id=6eb4e5c6&"
import script from "./ChartsBarPie.vue?vue&type=script&lang=js&"
export * from "./ChartsBarPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports